export class Group {
  groupDesc: string;
  groupId: string;
  hoID: number;
}
